import { Navigate } from 'react-router-dom';
import { getCurrentUser } from '@/utils/config';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const user = getCurrentUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
